import { render, staticRenderFns } from "./SSignedAmountInput.vue?vue&type=template&id=4d948ac9&scoped=true&"
import script from "./SSignedAmountInput.vue?vue&type=script&lang=ts&"
export * from "./SSignedAmountInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d948ac9",
  null
  
)

export default component.exports